export default "__VITE_ASSET__9484958a__"